
import axios from 'axios'

let baseUrl='/bc-sso-server'

// 意见反馈
export const setFeedback=(para)=>{
  return axios.post(baseUrl+'/feedback',para,{
    headers:{
      'Content-Type': 'application/json',
    }
  })
}

//新闻中心类型列表========
export const categoryList=(para)=>{
  return axios.get(baseUrl+'/open/articles/categoryList',{params:para},{
    headers:{
      'Content-Type': 'application/json',
    }
  })
}
//新闻中心类型列表详情=======
export const categoryDetail=(para)=>{
  return axios.get(baseUrl+'/open/articles/category/detail',{params:para},{
    headers:{
      'Content-Type': 'application/json',
    }
  })
}
